import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Box,
  Flex,
} from "@chakra-ui/react";
import { useRef } from "react";
import { FC, ReactNode } from "react";

interface AlertDialogComponentProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleButton?: () => void;
  text: ReactNode;
  title: string;
  buttonText: string;
}

const AlertDialogComponent: FC<AlertDialogComponentProps> = ({
  isOpen,
  setIsOpen,
  handleButton,
  text,
  title,
  buttonText,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        leastDestructiveRef={cancelRef}
        size="2xl"
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader as="h4" fontSize="xl" fontWeight="bold">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {title}
              </Box>
            </AlertDialogHeader>

            <AlertDialogBody fontSize="md" pb={4}>
              {text}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Flex
                gap={3}
                justifyContent="flex-end"
                alignItems="center"
                width="100%"
              >
                <Button
                  variant="tertiary"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  ref={cancelRef}
                >
                  Cancelar
                </Button>
                {handleButton && (
                  <Button
                    onClick={handleButton}
                    variant="primary"
                    colorScheme={buttonText === "Eliminar" ? "red" : "default"}
                  >
                    {buttonText}
                  </Button>
                )}
              </Flex>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AlertDialogComponent;
